export const spacing = {
  spacing: {
    'custom-space': '3rem',
  },
};
